import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'
import {NewsWrapper} from './styles'

function NewsPageSkeletonComponent() {
  return (
    <NewsWrapper>
      <div className="player-container">
        <Skeleton className="player" baseColor={colors.palette.neutral500} />
      </div>

      <div className="info">
        <Skeleton height={37} width="80%" className="title-bio" baseColor={colors.palette.neutral500} />
        <Skeleton height={700} width="100%" className="box" baseColor={colors.palette.neutral500} />
      </div>
    </NewsWrapper>
  )
}

export const NewsPageSkeleton = memo(NewsPageSkeletonComponent)
